<template>
  <bl-card-mv>
    <div :style="decoration">
      <div
        style="position: absolute; width: 56px; height: 56px; padding: 4px; top: -20%; background: white; border-radius: 4px; box-shadow: 0px 1px 5px rgba(31, 31, 31, 0.15);"
      >
        <img
          :src="product.logo_url"
          :alt="`logo-${product.name}`"
          width="48px"
          height="48px"
          style="width: 48px; height: 48px;"
        />
      </div>

      <bl-text-av
        class="mb-20 product-card__product-return"
        align="right"
        variation="body-14"
        weight="bold"
        color="inverse"
      >
        {{ productReturn }}
      </bl-text-av>

      <bl-flex-container-mv align-items="center">
        <bl-flex-item-av class="mr-10" :grow="1" :shrink="1">
          <bl-text-av class="product-card__product-name" :tag="productNameTag" :ellipsis="1" variation="caption-12">
            {{ product.name }}
          </bl-text-av>
          <bl-text-av class="product-card__product-type" variation="caption-10" color="subdued">
            {{ product.type }}
          </bl-text-av>
        </bl-flex-item-av>
        <bl-flex-item-av basis="105px" style="text-align: right;">
          <bl-button-av
            class="product-card__product-buy-button"
            variation="outline"
            size="small"
            @click="gotoLoginPage"
          >
            Beli produk
          </bl-button-av>
        </bl-flex-item-av>
      </bl-flex-container-mv>
    </div>
  </bl-card-mv>
</template>

<script>
import { assetURL } from 'shared/helpers/assetHelper';
import BlCardMv from '@bukalapak/bazaar-mweb-2/dist/components/BlCardMv';
import BlTextAv from '@bukalapak/bazaar-mweb-2/dist/components/BlTextAv';
import BlFlexContainerMv from '@bukalapak/bazaar-mweb-2/dist/components/BlFlexContainerMv';
import BlFlexItemAv from '@bukalapak/bazaar-mweb-2/dist/components/BlFlexItemAv';
import BlButtonAv from '@bukalapak/bazaar-mweb-2/dist/components/BlButtonAv';
import queryString from 'query-string';

export default {
  name: 'ProductCard',
  components: {
    BlCardMv,
    BlTextAv,
    BlFlexContainerMv,
    BlFlexItemAv,
    BlButtonAv,
  },
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
    productNameTag: {
      type: String,
      default: 'h3',
    },
  },

  computed: {
    isSSR() {
      return this.$root.isSSR;
    },

    productReturn() {
      const productReturn = this.product.return_one_month;

      const sign = productReturn < 0 ? '' : '+';

      return `${sign}${productReturn}%`;
    },

    decoration() {
      return {
        'background-repeat': 'no-repeat',
        'background-position': 'top center',
        'background-image': `url(${assetURL('product_card_decoration.png', this.isSSR)})`,
        'background-size': '100%',
        position: 'relative',
        padding: '8px 12px 12px',
      };
    },
  },

  methods: {
    gotoLoginPage() {
      window.location.href = `/login?${queryString.stringify({
        comeback: this.$route.fullPath,
        direct: 1,
      })}`;
    },
  },
};
</script>
